import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/api/auth.service';
import { LocalStorageService } from '../services/local/local-storage.service';

@Injectable({
  providedIn: 'root'
})
export class AuthenticateGuard implements CanActivate {

  constructor(
    private authService: AuthService,
    private localStorage: LocalStorageService,
  ) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {

    const TOKEN = this.localStorage.GetItem('currentUserIcemInv');
    if (!this.authService.isAuthenticated()) {
      this.authService.logout();
      return false;
    }
    if (state.url === "/dbobject" && TOKEN.Email !== "sys@clavisco.com") {
      return false
    }
    return true;
  }




}

